/* Interfaces */
import { Buyer } from './Buyer';
import { PaymentType } from './payment_types';

export interface IPayload {
  toJSON(): string;
}

export abstract class Payload implements IPayload {
  protected paymentType: PaymentType | undefined;
  protected buyer: Buyer;

  constructor(paymentType: PaymentType | undefined, buyer: Buyer) {
    this.paymentType = paymentType;
    this.buyer = buyer;
  }

  abstract toJSON(): string;
}

export interface PromoCodeAvailability {
  // promoCodeID: string | null;
}

export class PremiumPayload extends Payload implements PromoCodeAvailability {
  public tipsterPlanID: string;
  // public promoCodeID: string | null;

  constructor(
    ID: string,
    paymentType: PaymentType | undefined,
    buyer: Buyer,
    // promoCodeID: string | null,
  ) {
    super(paymentType, buyer);
    this.tipsterPlanID = ID;

    // this.promoCodeID = promoCodeID;
  }

  toJSON(): string {
    const body: any = {
      store: this.paymentType,
      buyer: this.buyer,
      tipster_plan_id: this.tipsterPlanID,
    };

    // if (this.promoCodeID) {
    //   body.promo_code_id = this.promoCodeID;
    // }

    return JSON.stringify(body);
  }
}

export class TipPurchasePayload extends Payload {
  public tipID: string;

  constructor(ID: string, paymentType: PaymentType | undefined, buyer: Buyer) {
    super(paymentType, buyer);
    this.tipID = ID;
  }

  toJSON(): string {
    return JSON.stringify({
      store: this.paymentType,
      buyer: this.buyer,
      tip_id: this.tipID,
    });
  }
}
